import React from 'react';
import styled from 'styled-components';

const Line = styled.p`
  font-size: var(--title-size);
  color: var(--korbank-purple);
  overflow-wrap: anywhere;
`

export const LineContent = (props) => (
  <Line>
    {props.content}
  </Line>
)